import script from "./AccountDetailsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDetailsTab.vue?vue&type=script&setup=true&lang=js"

import "./AccountDetailsTab.vue?vue&type=style&index=0&id=4f5054df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5054df"]])

export default __exports__